import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";

function fmtErr(d) {
  if (!d) return "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      nav(["super_admin", "admin", "sales"].includes(u.role) ? "/admin" : "/");
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/logo.png" alt="Faridabad Properties" className="h-12 w-auto" />
        </Link>
        <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
          <h1 className="font-heading text-2xl font-bold text-slate-900">Welcome back</h1>
          <p className="text-slate-500 text-sm mt-1">Login to your account or admin portal.</p>
          <form onSubmit={submit} className="space-y-4 mt-6" data-testid="login-form">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email" className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm" />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="login-password" className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm" />
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-indigo-900 hover:bg-indigo-800">{loading ? "Signing in…" : "Login"}</Button>
          </form>
          <p className="text-sm text-slate-500 mt-4 text-center">No account? <Link to="/signup" className="text-indigo-800 font-semibold">Sign up</Link></p>
        </div>
      </div>
    </div>
  );
}
